export const isString = (value: unknown): boolean => (typeof value === 'string') && (value !== '')

export const validateSpecChars = (str: string): boolean => {
    const pattern = /[<>^*$%#@{}:;'"+=!~`/?,.]/g
    return !pattern.test(str)
}

export const validateZip = (value: string): boolean => {
    const validRegex = /^[/\d]{5}?$/
    return !!value.match(validRegex)
}

export const validateCanadaZip = (value: string): boolean => {
    const validRegex = /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/
    return !!value.match(validRegex)
}
